/*
Don't change this file manually.
It is autogenerated by @plone/registry.
Instead, change the "addons" registration in the app.
*/
import plonevoltoSlate from '@plone/volto-slate';
import voltoDiscount from 'volto-discount';
import voltoApanymantel from 'volto-apanymantel';

const addonsInfo = [{"name":"@plone/volto-slate","version":"19.0.5","isPublishedPackage":true,"isRegisteredAddon":false,"modulePath":"/app/core/packages/volto-slate/src","hasServerConfig":false,"packageJson":"/app/core/packages/volto-slate/package.json","basePath":"/app/core/packages/volto-slate","tsConfigPaths":null,"addons":[]},{"name":"volto-discount","version":"1.0.1","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/app/packages/volto-discount/src","hasServerConfig":false,"packageJson":"/app/packages/volto-discount/package.json","basePath":"/app/packages/volto-discount","tsConfigPaths":[null,{"@plone/volto/*":["../../core/packages/volto/src/*"],"volto-discount/*":["./src/*"]}],"addons":[]},{"name":"volto-apanymantel","version":"1.0.3","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/app/packages/volto-apanymantel/src","hasServerConfig":false,"packageJson":"/app/packages/volto-apanymantel/package.json","basePath":"/app/packages/volto-apanymantel","tsConfigPaths":[null,{"@plone/volto/*":["../../core/packages/volto/src/*"],"volto-apanymantel/*":["./src/*"],"volto-discount":["../volto-discount/src"],"volto-discount/*":["../volto-discount/src/*"]}],"addons":["volto-discount"]}];
export { addonsInfo };

const safeWrapper = (func) => (config) => {
  const res = func(config);
  if (typeof res === 'undefined') {
    throw new Error("Configuration function doesn't return config");
  }
  return res;
}

const load = (config) => {
  const addonLoaders = [plonevoltoSlate, voltoDiscount, voltoApanymantel];
  if(!addonLoaders.every((el) => typeof el === "function")) {
    throw new TypeError(
      'Each addon has to provide a function applying its configuration to the projects configuration.',
    );
  }
  return addonLoaders.reduce((acc, apply) => safeWrapper(apply)(acc), config);
};
export default load;
